// import React, { useState, useEffect, useCallback } from "react"
// import Gallery from "react-photo-gallery"
// import { useSelector, useDispatch } from "react-redux"
// import { makeStyles } from "@material-ui/core/styles"
// import { Box, Snackbar } from "@material-ui/core"
// import MuiAlert from "@material-ui/lab/Alert"
// import styles from "./styles"
// // import SelectImage from "./selectImage"
// import { PageLayout } from '../../v2_components/layout/PageLayout'

// import {
//     getPhotosByGalleryNameAction,
//     addGalleryCount,
//     setAllChecked,
//     setShowDelRes,
//     setEditGalleryAble,
//     setUpdateGallery,
//     setGalleryPrice,
// } from "../../actions/gallery"
// import { setMapInfo } from "actions/map"
// import { updatePricebyPhotoId } from "../../apis"
// import "react-medium-image-zoom/dist/styles.css"
// import TopBar from "./topBar"
// import percentLoader, {
//     LoaderPercentProgressContainer,
// } from "./loaderComponent"
// import MapView from "../mapview"
// import GalleySideBar from "components/Sidebar/GallerySideBar"
// import { getLoggedInUserId, getUserStoredCountry } from '../../v2_actions/auth'

// const useStyles = makeStyles(styles)

// function Alert(props) {
//     return <MuiAlert elevation={6} variant="filled" {...props} />
// }

// const ImageGallery = () => {
//     let photoArray = []
//     const classes = useStyles()
//     const dispatch = useDispatch()
//     const country = getUserStoredCountry()

//     const [imgs, setImgs] = useState([])
//     const [message, setMessage] = useState("")
//     const [buttonZoom, setButtonZoom] = useState(0)
//     const [scrollZoom, setScrollZoom] = useState(0)
//     const [openModal, setOpenModal] = useState(false)
//     const [width, setWidth] = useState(window.innerWidth)
//     const [openSnackBar, setOpenSnackBar] = useState(false)
//     const [updatePriceValue, setUpdatePriceValue] = useState()
//     const [changePriceStatus, setChangePriceStatus] = useState(false)

//     const pIds = useSelector((state) => state.gallery.pIds)
//     const mapInfo = useSelector((state) => state.mapinfo.mapInfo)
//     const galleryPrice = useSelector((state) => state.gallery.price)
//     const showDelRes = useSelector((state) => state.gallery.showDelRes)
//     const galleryId = useSelector((state) => state.gallery.galleryId)
//     const galleryPhotos = useSelector((state) => state.gallery.galleryPhotos)
//     const showLoadingSpiner = useSelector((state) => state.gallery.showSpiner)
//     const galleryAllList = useSelector((state) => state.gallery.galleryAllList)
//     const mapSearchViewAble = useSelector((state) => state.gallery.mapSearchViewAble)

//     useEffect(() => {
//         window.addEventListener("resize", updateWidth)
//         return () => window.removeEventListener("resize", updateWidth)
//     })

//     const updateWidth = () => {
//         setWidth(window.innerWidth)
//     }

//     useEffect(() => {
//         if (showLoadingSpiner) percentLoader.open({ percentage: 0, speed: 20 })
//     }, [showLoadingSpiner])

//     useEffect(() => {
//         if (galleryPhotos && galleryPhotos.length > 0) {
//             // eslint-disable-next-line
//             makePhotoLayoutArr()
//         } else {
//             setImgs([])
//         }
//         // eslint-disable-next-line
//     }, [galleryPhotos, galleryPrice])

//     useEffect(() => {
//         if (showDelRes) {
//             setOpenSnackBar(true)
//             if (showDelRes === "success") {
//                 setMessage("Deleted photos successful!")
//             } else if (showDelRes === "sold") {
//                 setMessage(
//                     "You cannot delete photos that have been sold to customers!"
//                 )
//             } else {
//                 setMessage("Gallery remove successful!")
//             }
//             dispatch(setShowDelRes(false))
//         }
//         // eslint-disable-next-line
//     }, [showDelRes])

//     useEffect(() => {
//         if (buttonZoom > 300) setButtonZoom(0)
//         if (buttonZoom < 0) setButtonZoom(0)
//     }, [buttonZoom])

//     useEffect(() => {
//         if (scrollZoom > 300) setScrollZoom(0)
//         if (scrollZoom < 0) setScrollZoom(0)
//     }, [scrollZoom])

//     const makePhotoLayoutArr = () => {
//         let zoom = scrollZoom > 0 ? scrollZoom : buttonZoom
//         // eslint-disable-next-line
//         galleryPhotos.map((item) => {
//             let check_img_src = item.lower_res_image.includes("small_photos")
//             const data = {
//                 id: parseInt(item.id),
//                 price: item.price,
//                 src: check_img_src
//                     ? `${window.LOCAL_SETTINGS.API_BASE}/media/${item.lower_res_image}`
//                     : item.lower_res_image,
//                 height: parseInt(item.height),
//                 width:
//                 zoom > 0
//                     ? parseInt(parseInt(item.width) * (1 + zoom / 100))
//                     : parseInt(item.width),
//             }
//             photoArray.push(data)
//         })
//         setImgs(photoArray)
//     }

//     useEffect(() => {
//         if (pIds.length === 0) dispatch(setAllChecked(false))
//         // eslint-disable-next-line
//     }, [pIds])

//     const editGallery = (existGalleryId) => {
//         const updateGallery = galleryAllList.filter(
//             (item) => item.id === existGalleryId
//         )
//         let lat = updateGallery[0]["lat"]
//         let lng = updateGallery[0]["lng"]
//         let newMapInfo = { lat: lat, lng: lng }
//         dispatch(
//             setMapInfo({ ...mapInfo, position: newMapInfo, showAddress: true })
//         )
//         dispatch(setEditGalleryAble(true))
//         dispatch(setUpdateGallery(updateGallery[0]))
//         dispatch(setGalleryPrice(true))
//     }

//     const changePrice = () => {
//         const sendData = {
//             pids: pIds,
//             price: updatePriceValue,
//         }
//         updatePricebyPhotoId(sendData).then((res) => {
//             if (res.data === "success") {
//                 dispatch(getPhotosByGalleryNameAction(galleryId))
//                 setOpenModal(false)
//                 setOpenSnackBar(true)
//                 setMessage("Update price successful!")
//                 dispatch(addGalleryCount(0))
//                 setChangePriceStatus(true)
//             }
//         })
//     }

//     const imageRenderer = useCallback(
//         ({ photo }) => (
//             <SelectImage
//               key={`${photo.id}-gallery-selectimg`}
//               photo={photo}
//               setUpdatePriceValue={setUpdatePriceValue}
//               changePriceStatus={changePriceStatus}
//               setChangePriceStatus={setChangePriceStatus}
//               setOpenSnackBar={setOpenSnackBar}
//               setMessage={setMessage}
//             />
//         ),
//         // eslint-disable-next-line
//         [
//             setUpdatePriceValue,
//             changePriceStatus,
//             setChangePriceStatus,
//             setOpenSnackBar,
//             setMessage,
//         ]
//     )

//     const onscroll = (e) => {
//         setButtonZoom(0)
//         if (e.altKey === true) {
//             if (e.deltaY > 0) {
//                 setScrollZoom(scrollZoom - 30)
//                 makePhotoLayoutArr()
//             } else if (e.deltaY < 0) {
//                 setScrollZoom(scrollZoom + 30)
//                 makePhotoLayoutArr()
//             }
//         }
//     }


//     return (


//         <PageLayout message={message}>
          
//           <div
//             style={{ background: "white", position: "releative" }}
//             onWheelCapture={onscroll}
//           >
//             <TopBar
//               classes={classes}
//               width={width}
//               makePhotoLayoutArr={makePhotoLayoutArr}
//               changePrice={changePrice}
//               openModal={openModal}
//               setOpenModal={setOpenModal}
//               buttonZoom={buttonZoom}
//               setButtonZoom={setButtonZoom}
//               updatePriceValue={updatePriceValue}
//               setUpdatePriceValue={setUpdatePriceValue}
//             />
//             {mapSearchViewAble ? (
//                 <MapView mapLink={mapInfo.mapLink}/>
//             ) : (
//                 <>
//                   {" "}
//                   {showLoadingSpiner === false ? (
//                       <Box className={classes.middleBar}>
//                         {imgs.length > 0 && (
//                             <Gallery
//                               photos={imgs}
//                               direction={"row"}
//                               cols={2}
//                               renderImage={imageRenderer}
//                             />
//                         )}
//                       </Box>
//                   ) : (
//                       <div className={classes.progressWrapper}>
//                         <LoaderPercentProgressContainer />
//                       </div>
//                   )}
//                 </>
//             )}
            
//           </div>
//         </PageLayout>
//     )
// }

// export default ImageGallery


import React from 'react'

export default () => {
    return (
        <div>
            <h1>Image Gallery</h1>
        </div>
    )
}